import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

//
//
//
///  ------ ------ ------ ------ ------ ------ ------ ------ ------ ------
export function splitText() {
  const splitToLines = document.querySelectorAll(
    "[splitting], [split], [perex]"
  );

  if (splitToLines) {
    splitToLines.forEach((el) => {
      if (!el.classList.contains("splitting")) {
        var results = Splitting({
          target: el,
          by: "words",
        });

        const words = el.querySelectorAll(".word");
        const total = words.length;
        const lines = 3;
        const fraction = Math.floor(total / lines);

        const fraction2 = fraction + fraction;
        if (words[fraction].nextSibling) {
          words[fraction].nextSibling.classList.add("break");
        }
        if (words[fraction2].nextSibling) {
          words[fraction2].nextSibling.classList.add("break");
        }
      }
    });
  }
  //
  //
  //
  ///  ------ ------ ------ ------ ------ ------ ------ ------ ------ ------
  const splitToWords = document.querySelectorAll("[subpage]");
  if (splitToWords) {
    splitToWords.forEach((el) => {
      if (!el.classList.contains("splitting")) {
        var results = Splitting({
          target: el,
          by: "words",
        });
      }
    });
  }
}
